import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';

import useGlobalStatus from '../../hook/useGlobalStatus';
import { ALERT_TYPE } from '../../constants/alertMsg';

const SlideTransition = (props) => {
  return <Slide {...props} direction="down" />;
}

const AlertMsg = (props) => {
  const { isAlertMsgOpen, setIsAlertMsgOpen, alertMsgData } = useGlobalStatus();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setIsAlertMsgOpen(false);
  };

  return (
    <Snackbar
      open={isAlertMsgOpen}
      autoHideDuration={2000}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      TransitionComponent={SlideTransition}
      onClose={handleClose}
      sx={{ zIndex: 2000 }}
    >
      <Alert
        variant="filled"
        severity={alertMsgData.type || ALERT_TYPE.SUCCESS}
        sx={{
          width: '100%',
          color: '#fff',
        }}
        onClose={handleClose}
      >
        {alertMsgData.msg}
      </Alert>
    </Snackbar>
  );
};

export default AlertMsg;